/*
Copyright (c) 2025 Mathilde Meyer, Naziha Beghdadi
Licensed under the MIT License (see LICENSE.txt file for details)
*/

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  Typography,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
// message d'erreur home
export default function IntroductionDialog({ open, handleConfirm, finished }) {
  
  return (
    <Dialog
      open={open}
      onClose={() => handleConfirm(false)}
      sx={{ "& .MuiPaper-root": { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningAmberIcon color={finished ? "info" : "warning"} />
        Return to Home
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ p: 3 }}>
        <Typography variant="body1">
          Are you sure you want to return to Home? <br />
          <strong>All unsaved changes will be lost.</strong>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={() => handleConfirm(false)} variant="outlined" color="inherit">
          No
        </Button>
        <Button onClick={() => handleConfirm(true)} variant="outlined" color="inherit">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
